import { UserRoles } from '@securecore-new-application/securecore-datacore/lib/types';
import { Navigate } from 'react-router-dom';

import { useCurrentUser, useGetToken } from '../../hooks';
import { ErrorPage, ErrorPageTypes } from '../Errors';

interface Props {
  children: JSX.Element;
  access: UserRoles[];
}

export function PrivateRoute({ access, children }: Props) {
  const { token } = useGetToken();
  const currentUser = useCurrentUser();

  if (!token) {
    return <Navigate to="/auth" replace />;
  }

  if (!access.find((item) => item === currentUser?.role)) {
    return <ErrorPage type={ErrorPageTypes.unknown} />;
  }

  return children;
}
